import type { ConsultationRow, LevelKey } from '@/pages/admin/types';

export interface LevelInfo {
  key: LevelKey;
  label: string;
  shortLabel: string;
  badgeClass: string;
  dotClass: string;
}

export function levelOf(row: ConsultationRow): LevelInfo {
  if (!row.rated_count) {
    return {
      key: 'none',
      label: '未评估',
      shortLabel: '未评估',
      badgeClass: 'bg-secondary-100 text-foreground-600 border-secondary-200',
      dotClass: 'bg-secondary-400',
    };
  }

  if (row.total_score >= 23) {
    return {
      key: 'severe',
      label: '偏重，建议尽早就诊',
      shortLabel: '偏重',
      badgeClass: 'bg-primary-500 text-background-50 border-primary-500',
      dotClass: 'bg-primary-500',
    };
  }

  if (row.total_score >= 13) {
    return {
      key: 'moderate',
      label: '中度不适',
      shortLabel: '中度',
      badgeClass: 'bg-accent-100 text-accent-900 border-accent-300',
      dotClass: 'bg-accent-500',
    };
  }

  return {
    key: 'mild',
    label: '轻度波动',
    shortLabel: '轻度',
    badgeClass: 'bg-primary-50 text-primary-700 border-primary-200',
    dotClass: 'bg-primary-300',
  };
}

export const levelFilters: { key: LevelKey | 'all'; label: string }[] = [
  { key: 'all', label: '全部' },
  { key: 'severe', label: '偏重' },
  { key: 'moderate', label: '中度' },
  { key: 'mild', label: '轻度' },
  { key: 'none', label: '未评估' },
];